// Labels for the correction of failed Accounts payments (LB-766).

export const PCMP_CORRECTION_ACTION_COPY = {
  EDIT: {
    label: 'Correct Payment',
    title: 'Correct Payment Details',
    submit: 'Save correction',
    toast: 'Payment details corrected',
  },
  APPROVE: {
    label: 'Approve Correction',
    title: 'Approve Correction',
    submit: 'Approve',
    toast: 'Correction approved — sent to Accounts for re-disbursement',
  },
} as const;
